import { canWrite } from '@renalflow/core';
import { useOptionalAccount } from './AccountGate';

/** False when the plan has lapsed (read-only). Always true in the demo, which has no account. */
export function useCanWrite() {
  const account = useOptionalAccount();
  return !account || canWrite(account.entitlement.state);
}
